<template>
<div class="card">
   <h6>YOUR CURRENT ENERGY SUPPLY</h6>
   <h4>{{ defaultSupplier == quote.gasSupplierId ? 'Your gas is currently provided by' : 'Who is your current gas supplier?' }}</h4>

   <loader :show="loading.suppliersGas"></loader>
   <div class="form-group" v-if="!loading.suppliersGas">
      <div class="col-sm-7">
          <div class="row" v-show="quote.gasSupplierId">
              <div class="col-xs-6 col-md-5">
                  <div class="company-logo _margin-top-10 _margin-bottom-20" :class="`supplier-${quote.gasSupplierId}`"></div>
              </div>

              <div class="col-xs-6 col-md-7">
                  <uiv-btn class="_margin-top-10" type="link" @click="quote.gasSupplierId = null">
                      Change
                  </uiv-btn>
              </div>
          </div>

          <div v-show="!quote.gasSupplierId">
              <form-label id="supplierGas">Select your supplier</form-label>
              <validation-messages label="Supplier" :$v="$v.gasSupplierId">
                <select-list id="supplierGas"
                   v-model="quote.gasSupplierId"
                   value-key="id"
                   label-key="name"
                   :list="supplierGasList"
                   :error="$v.gasSupplierId.$error"
                   @change="onChooseSupplier"
                />
              </validation-messages>
          </div>
      </div>
   </div>

   <div v-show="quote.gasSupplierId">
      <loader :show="loading.tariffsGas"></loader>
      <div class="form-group _margin-bottom-30" v-if="!loading.tariffsGas">
         <div class="col-sm-7">
            <form-label id="gasTariff">
               {{ quote.gasTariff.name ? 'Your tariff' : 'Select your plan' }}
               <button type="button" class="btn-i" v-if="!quote.gasTariff.name" v-uiv-tooltip.right="'You will find what plan you\'re on by looking at your latest bill'">i</button>
            </form-label>
            <validation-messages label="Tariff" :$v="$v.gasTariff.id">
               <select-list id="gasTariff"
                  v-model="quote.gasTariff.id"
                  value-key="id"
                  label-key="name"
                  :list="tariffGasList"
                  :error="$v.gasTariff.id.$error"
                  @change="onChooseTariff"
               />
            </validation-messages>
         </div>
      </div>

      <div class="form-group" v-show="quote.gasTariff.isFixedFromEnergyStartDate">
         <div class="col-sm-7">
            <form-label id="gasTariffValidToDate">Tariff End Date</form-label>
            <validation-messages label="Tariff End Date" :$v="$v.gasTariffValidToDate">
               <date-field
                  id="gasTariffValidToDate"
                  v-model="quote.gasTariffValidToDate"
                  :error="$v.gasTariffValidToDate.$error"
               />
            </validation-messages>
         </div>
      </div>
   </div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'SupplierTariffGas',
  props: {
    $v: Object
  },
  data () {
    return {
      requesting: false
    };
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      supplierList: ({ lookups }) => lookups.suppliers,
      loading: ({ lookups }) => lookups.requesting,
      supplierGasList: ({ lookups }) => lookups.suppliersGas,
      tariffGasList: ({ lookups }) => lookups.tariffsGas,
      defaultSupplier: ({ quote }) => {
          const address = quote.address.parts;
          if(!address) return false;
          const gasdetails = address.gasdetails.find(({ isDomestic }) => isDomestic) || {};

          return gasdetails.mugSupplierId ? gasdetails.mugSupplierId : false;
      }
    })
  },
  watch: {
    tariffGasList (value) {
      const defaultTariffFound = value.find(({ isDefaultOrStandard }) => isDefaultOrStandard);

      if (defaultTariffFound) {
        this.onChooseTariff(defaultTariffFound.id);
      }
    }
  },
  methods: {
    ...mapActions({
      getTariffs: 'lookups/getTariffs'
    }),
    async onChooseSupplier (id) {
      this.quote.gasTariff = {};
      this.quote.gasSupplierId = id;
      this.quote.gasTariffValidToDate = null;
      await this.getTariffs({ fuelType: 'gas', supplierId: id });
    },
    onChooseTariff (tariffId) {
      if (!tariffId) return;
      const selected = this.tariffGasList.find(({ id }) => id == tariffId);
      this.quote.gasTariff = { ...selected };

      if (!selected.isFixedFromEnergyStartDate) {
        this.quote.gasTariffValidToDate = null;
      }
    }
  }
};
</script>

<style lang="scss">
</style>
